import { Component, OnInit } from '@angular/core';
import { SwUpdate, VersionReadyEvent } from '@angular/service-worker';
import { environment } from 'env/environment';
import packageJson from '../../package.json';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  standalone: false,
})
export class AppComponent implements OnInit {
  readonly version = packageJson.version;
  readonly angularVersion = packageJson.dependencies['@angular/core'];
  readonly showVersion = !environment.production;

  constructor(private readonly swUpdate: SwUpdate) {}

  ngOnInit() {
    window['version'] = environment.version;
    window['blipAppKey'] = environment.blipAppKey;

    if (this.swUpdate.isEnabled) {
      this.swUpdate.versionUpdates.subscribe((evt) => {
        if (evt.type === 'VERSION_READY') {
          this.swUpdate.activateUpdate().then(() => window.location.reload());
        }
      });
    }
  }
}
